var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var treeDashboard = require ('../../components/treeDashboard');
var treeLocation = require ('../../locations/treeLocationAndEquipment');
var Dashboard = Object.assign(require('../../../../../models/dashboards/dashboard'), Model);
var DashboardTree = {root: Dashboard, name: 'Home', leafClass: 'Dashboard', edgeClass: 'Contains', ancestorClass: 'ancestors', '@id': '/api/v1/dashboardonly/'};

var copyModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


copyModal.editDialogue = function (record, options) {
  copyModal.newParentId = prop('')
  copyModal.record = record
  copyModal.errors = [];
  var submit = () => {
    copyModal.errors = [];
    var newParent = copyModal.newParentId();
    var newParentRid = newParent && newParent['@rid'];
    if (!newParentRid) {
      copyModal.errors = [
        record.in_Contains && record['@class'] != 'Dataset'
          ? 'Select a parent dashboard before saving.'
          : 'Select a parent location before saving.'
      ];
      m.redraw();
      return false;
    }

    return loaders.requestWithLoader({
      loader: 'submit',
      url: `/api/v1/${record['@class'].toLowerCase()}/${record['@rid'].slice(1)}/copy`,
      method: 'POST',
      body:{ 
        newParentId: newParentRid.slice(1)
      }
    })
    .then(function (result) {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    });
  };
  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(`Copy ${record['@class']}`);
  modal.vm.body = copyModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


copyModal.view = function () {
  if (!copyModal.record) return;
  if (copyModal.record.in_Contains && copyModal.record['@class'] != 'Dataset') {
    return m('form', {role:'form'}, [
      copyModal.errorView(),
      m(treeDashboard, {
        trees: [DashboardTree], 
        selector: copyModal.newParentId, 
        label:'parent dashboard'
      })
    ])
  }
  if (copyModal.record.in_hasElement || copyModal.record['@class'] === 'Dataset') {
    return m('form', {role:'form'}, [
      copyModal.errorView(),
      m(treeLocation, {
        selectedNode: copyModal.newParentId, 
        equipmentRecord: copyModal.record,
        label:'parent location'
      })
    ])
  }
}

module.exports = copyModal;
